import React, { useState } from "react";
import HappySchoolPeriodTimes from "./HappySchoolPeriodTimes";
import HappySchoolTKBManager from "./HappySchoolTKBManager";
import HappySchoolScheduleRules from "./HappySchoolScheduleRules";

// Lịch bận, Phân bổ nghề-văn hoá, Chạy xếp lịch đã gộp vào Tree "Quản lý TKB".
// Phân công chuyên môn + Số tiết đã chuyển sang nhóm "Quản lý dạy học".
const TABS = [
  { key: "quanlytkb", label: "Quản lý TKB", Component: HappySchoolTKBManager },
  { key: "quytac", label: "Quy tắc TKB", Component: HappySchoolScheduleRules },
  { key: "giohoc", label: "Thời gian học", Component: HappySchoolPeriodTimes },
];

const HappySchoolScheduleHub = () => {
  const [activeTab, setActiveTab] = useState(TABS[0].key);
  const ActiveComponent = TABS.find((t) => t.key === activeTab).Component;

  return (
    <div
      style={{
        padding: 24,
        maxWidth: 1200,
        margin: "0 auto",
        overflowX: "hidden",
        background: "#E3F2FD",
        borderRadius: 12,
        // Lấp đầy chiều cao thật của cột Main (cột quảng cáo bên cạnh có
        // thể cao hơn nội dung của mình) — tránh lộ nền trắng mặc định của
        // wrapper cha ở phần dư ra bên dưới.
        minHeight: "100%",
        boxSizing: "border-box",
      }}
    >
      <h2 style={{ margin: "0 0 16px 0" }}>Xếp thời khoá biểu</h2>

      <div style={{ display: "flex", gap: 4, flexWrap: "wrap", borderBottom: "2px solid #e5e7eb", marginBottom: 20 }}>
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setActiveTab(t.key)}
            style={activeTab === t.key ? tabBtnActiveStyle : tabBtnStyle}
          >
            {t.label}
          </button>
        ))}
      </div>

      <ActiveComponent />
    </div>
  );
};

const tabBtnStyle = {
  padding: "10px 16px",
  background: "transparent",
  color: "#4b5563",
  border: "none",
  borderBottom: "3px solid transparent",
  cursor: "pointer",
  fontSize: 14,
  fontWeight: 500,
  marginBottom: -2,
};
const tabBtnActiveStyle = {
  ...tabBtnStyle,
  color: "#0ea5a3",
  borderBottomColor: "#0ea5a3",
  fontWeight: 700,
};

export default HappySchoolScheduleHub;
